import React, { Suspense } from 'react';
import SiteLayout from '../components/layout/SiteLayout';
import HeroSection from '../features/landing/sections/HeroSection';
import LandingMetaTags from '../features/landing/LandingMetaTags';

// Lazy load components
const EmailDictationSection = React.lazy(() => import('../features/landing/sections/EmailDictationSection'));
const ChatDictationSection = React.lazy(() => import('../features/landing/sections/ChatDictationSection'));
const FeatureOverviewSection = React.lazy(() => import('../features/landing/sections/FeatureOverviewSection'));
const TestimonialsPreviewSection = React.lazy(() => import('../features/landing/sections/TestimonialsPreviewSection'));
const PricingSection = React.lazy(() => import('../features/pricing/PricingSection'));
const VoiceInkFaqSection = React.lazy(() => import('../features/faq/VoiceInkFaqSection'));
const OpenSourceSection = React.lazy(() => import('../features/landing/sections/OpenSourceSection'));

export default function HomePage() {
  return (
    <SiteLayout>
      <LandingMetaTags />
      <HeroSection />
      <Suspense fallback={<div className="min-h-[400px] flex items-center justify-center">Loading...</div>}>
        <EmailDictationSection />
      </Suspense>
      <Suspense fallback={<div className="min-h-[400px] flex items-center justify-center">Loading...</div>}>
        <ChatDictationSection />
      </Suspense>
      <Suspense fallback={<div className="min-h-[400px] flex items-center justify-center">Loading...</div>}>
        <FeatureOverviewSection />
      </Suspense>
      <Suspense fallback={<div className="flex items-center justify-center py-12">Loading...</div>}>
        <TestimonialsPreviewSection />
      </Suspense>
      <Suspense fallback={<div className="min-h-[400px] flex items-center justify-center">Loading...</div>}>
        <PricingSection />
      </Suspense>
      <Suspense fallback={<div className="min-h-[400px] flex items-center justify-center">Loading...</div>}>
        <VoiceInkFaqSection />
      </Suspense>
      <Suspense fallback={<div className="min-h-[400px] flex items-center justify-center">Loading...</div>}>
        <OpenSourceSection />
      </Suspense>
    </SiteLayout>
  );
}
